import { useState, useEffect, useContext, FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { listarProcessos, apagarProcesso } from '../../services/processos'
import { processosListaResposta } from '../../interfaces/processos'
import { ProcessosContext } from '../../contexts/Processos'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { descriptografarDado } from '../../helpers'
import { usuariosRespostaPayload } from '../../interfaces/usuarios'
import { modelosProcessosListaResposta } from '../../interfaces/modelosProcessos'
import { listarUsuariosOrganizacao } from '../../services/usuarios'
import { listarModelosProcessos } from '../../services/modelosProcessos'
import { Button, Loader } from '../Styles'
import Permissao from '../../middleware/Permissoes'
import ModalProcessos from '../ModalProcessos'
import FiltrosDefault from '../FiltrosDefault'
import avatarDefault from '../../assets/img/avatarDefault.png'
import apagarImg from '../../assets/img/excluir.png'
import DivSituacao from '../DivSituacao'
import LoagindBarra from '../LoadingBarra'
import Notificacoes from '../Notificacoes'
import confirmacaoImg from '../../assets/img/confirmacao.png'
import erroImg from '../../assets/img/erroFechar.png'
import maisFiltrosImg from '../../assets/img/maisFiltros.png'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import '../../styles/paginaListaDados.css'
import './processos.css'
import { toast } from 'react-toastify'

function Processos () {

    const { modal , modalExibir} = useContext(ModalEstadoContext)
    const { atualizarDadosProcesso, atualizarInformacoesProcesso } = useContext(ProcessosContext)

    const navigate = useNavigate()
    const location = useLocation()

    const { pathname, search } = location

    const [processos, setProcessos] = useState<processosListaResposta[]>([])
    const [processoSelecionado, setProcessoSelecionado] = useState<processosListaResposta>()
    const [cliente, setCliente] = useState('')
    const [situacao, setSituacao] = useState('ativo')
    const [processando, setProcessando] = useState(false)
    const [nenhumResultado, setNenhumResultado] = useState(false)
    const [excluirProcesso, setExluirProcesso] = useState(false)
    const [erro, setErro] = useState(false)

    const data = new Date()

    const ano = data.getFullYear()
    const qtnDias = new Date(data.getFullYear(), data.getMonth() + 1, 0).getDate()
    const dataAnterior = new Date(new Date().setDate(new Date().getDate() - 360))

    const [dataInicial, setDataInicial] = useState(`${dataAnterior.getFullYear()}-${(dataAnterior.getMonth() + 1).toString().padStart(2, '0')}-01`);
    const [dataFinal, setDataFinal] = useState(`${ano}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${qtnDias}`);
    const [maisFiltros, setMaisFiltros] = useState(false);
    const [responsavel, setResponsavel] = useState('');
    const [titulo, setTitulo] = useState('')
    const [responsaveis, setResponsaveis] = useState<usuariosRespostaPayload[]>([])
    const [modelosProcessos, setModelosProcessos] = useState<modelosProcessosListaResposta[]>([])
    const [tipo, setTipo] = useState("");
    const [tipoData, setTipoData] = useState("criado")

    const paramsUrl = new URLSearchParams(search)
    const processosEscritorio = paramsUrl.get('escritorio') ?? "false"

    const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))

    const exibirModalProcessos = () => modalExibir('processo')

    const exibirModalDadosProcessos = (processo: processosListaResposta, idProcesso: string) => {

        if (processosEscritorio) {
            
            navigate(`${pathname}?escritorio=true&idProcesso=${idProcesso}`)
            modalExibir('processo')

            return setProcessoSelecionado(processo)
        }

        navigate(`${pathname}?idProcesso=${idProcesso}`)
        modalExibir('processo')

        return setProcessoSelecionado(processo)
    }

    const buscarProcessos = async (e: FormEvent) => {
        e.preventDefault()
        const permissoesAutorizadas = ['master', 'administrativo', 'processo_todos']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        setNenhumResultado(false)
        setProcessando(true)

        const params = {
            cliente,
            situacao,
            processosEscritorio: temPermissao ? processosEscritorio : "false",
            responsavel,
            idModeloProcesso: tipo,
            titulo,
            tipoData,
            dataInicial,
            dataFinal,
        }

        try {

            const resposta = await listarProcessos(params)

            if (resposta.data.length === 0) {
                setProcessos(resposta.data)
                setProcessando(false)

                setMaisFiltros(false)
                return setNenhumResultado(true)
            }

            if (resposta.status === 200) {
                setProcessos(resposta.data)

                setMaisFiltros(false)
                return setProcessando(false)
            }
            
        } catch (error) {
            setProcessando(false)
            setErro(true)

            return setTimeout(() => {
                setErro(false)
            }, 2000)
        }
    }

    const deletarProcesso = async (idProcesso: string) => {

        setProcessando(true)

        try {

            const resposta = await apagarProcesso(idProcesso)

            if(resposta.status === 200) {
                setProcessando(false)
                setExluirProcesso(true)
                atualizarDadosProcesso()

                return setTimeout (() => {
                    setExluirProcesso(false)
                }, 2000)

            }
            
        } catch (error) {

            setProcessando(false)
            setErro(true)

            return setTimeout(() => {
                setErro(false)
            }, 2000)
            
        }

    }

    useEffect (() => {

        if(!modal.nome) setProcessoSelecionado(undefined)

    }, [modal])

    useEffect(() => {

        const buscarProcessos = async () => {
            const permissoesAutorizadas = ['master', 'administrativo', 'processo_todos']
            const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

            setNenhumResultado(false)
            setProcessando(true)

            const params = {
                cliente: '',
                situacao: 'ativo',
                processosEscritorio: temPermissao ? processosEscritorio : "false",
                dataInicial,
                dataFinal
            }

            try {

                const resposta = await listarProcessos(params)

                if (resposta.data.length === 0) {
                    setProcessos(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if (resposta.status === 200) {
                    setProcessos(resposta.data)

                    return setProcessando(false)
                }
                
            } catch (error) {
                    setProcessando(false)
                    return toast.error("Erro ao buscar os Processos.")
            }
        }

        buscarProcessos ()

    }, [processosEscritorio, atualizarInformacoesProcesso])

    useEffect(() => {

        const buscarResponsaveis = async () => {

            try {

                const params = {
                    termo: '',
                    situacao: 'ativo'
                }

                const resposta = await listarUsuariosOrganizacao(params)

                if (resposta.status === 200) {
                    return setResponsaveis(resposta.data)
                }

            } catch (error) {

                return alert('Falha ao Listar os Responsáveis')

            }
        }

        buscarResponsaveis()

    }, [])

    useEffect(() => {
        const buscarModelos = async () => {
            setNenhumResultado(false)
            setProcessando(true)

            const params = {
                termo: '',
                situacao: 'ativo'
            }

            try {

                const resposta = await listarModelosProcessos(params)

                if (resposta.data.length === 0) {
                    setModelosProcessos(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if (resposta.status === 200) {
                    setModelosProcessos(resposta.data)

                    return setProcessando(false)
                }

            } catch (error) {
                setProcessando(false)
                setErro(true)

                return setTimeout(() => {
                    setErro(false)
                }, 2000)

            }
        }

        buscarModelos()

    }, [])


    return (
        <div id='paginaContainer'>
            {modal.nome === 'processo' && <ModalProcessos processo={processoSelecionado}/>}
            {processando && <LoagindBarra />}
            {nenhumResultado && <NenhumResultadoEncontrado />}
            {excluirProcesso && <Notificacoes icone={confirmacaoImg} texto='Processo Exclúido com Sucesso' cor='sucesso' />}
            {erro && <Notificacoes icone={erroImg} texto='Falha ao Processar a Solicitação. Tente Novamente!' cor='erro' />}
            <FiltrosDefault termo={cliente} situacao={situacao} placeholder='Pesquise pelo nome fantasia do cliente' tipo={'processo'} onChangeTermo={(e) => setCliente(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarProcessos} acaoBtn={exibirModalProcessos} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Ativos', valor: 'ativo' }, { nome: 'Cancelados', valor: 'cancelado' }, { nome: 'Concluídos', valor: 'concluído' }]} genero='masculino' maisFiltros={true} acaoMaisFiltro={() => setMaisFiltros(true)} isLoading={processando} />
            {maisFiltros && <section id='maisOpcoesFiltrosTarefas'>
                <form id='maisOpcoesFiltrosTarefasContainer' onSubmit={buscarProcessos}>
                    <span id='filtrosContainerTitulo'>
                        <img id='filtrosAvancadosTarefas' src={maisFiltrosImg} alt='' />
                        <p>Filtros Avançados</p>
                    </span>
                    <section id='opcoesFiltrosTarefas'>
                        <section>
                            <span>
                                <label htmlFor="clienteFiltroTarefas">Cliente</label>
                                <input
                                    id='clienteFiltroTarefas'
                                    placeholder='Pesquise pelo nome Fantasia do Cliente'
                                    type="text"
                                    value={cliente}
                                    onChange={(e) => setCliente(e.target.value)} />
                            </span>
                        </section>
                        <section>
                            {search === "?escritorio=true" && <span>
                                <label htmlFor="responsaveltarefa">Responsável</label>
                                <select id='responsaveltarefa' value={responsavel} onChange={(e) => setResponsavel(e.target.value)}>
                                    <option value="">Todos</option>
                                    {responsaveis.map((responsavel) => (
                                        <option key={responsavel.id} value={responsavel.id}>{responsavel.nome}</option>
                                    ))}
                                </select>
                            </span>}
                            <span>
                                <label htmlFor="responsaveltarefa">Tipo do Processo</label>
                                <select id='responsaveltarefa' value={tipo} onChange={(e) => setTipo(e.target.value)}>
                                    <option value="">Todos</option>
                                    {modelosProcessos.map((modelo) => (
                                        <option key={modelo.id} value={modelo.id}>{modelo.titulo}</option>
                                    ))}
                                </select>
                            </span>
                        </section>

                        <section>
                            <span>
                                <label htmlFor="tituloTarefaFiltro">Título do Processo</label>
                                <input
                                    id='tituloTarefaFiltro'
                                    type="text"
                                    value={titulo}
                                    placeholder='Pesquise pelo título do processo'
                                    onChange={(e) => setTitulo(e.target.value)} />
                            </span>

                            {search !== '?automaticas=true' && <span>
                                <label htmlFor="situacaoFiltroTarefa">Situação</label>
                                <select id="situacaoFiltroTarefa" value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                                    <option value="">Todas</option>
                                    <option value="ativo">Ativos</option>
                                    <option value="cancelado">Cancelados</option>
                                    <option value="concluído">Conclúidos</option>
                                </select>
                            </span>}
                        </section>
                        <section>
                            <span>
                                <label htmlFor="tipoDataFiltro">Filtrar Data Por:</label>
                                <select
                                    id="tipoDataFiltro"
                                    value={tipoData}
                                    onChange={(e) => setTipoData(e.target.value)}
                                >
                                    <option value="criado">Data de Criação</option>
                                    <option value="prazo">Prazo do Processo</option>
                                </select>
                            </span>
                            <span>
                                <label htmlFor="dataInicialFiltrotarefas">Data Inicial</label>
                                <input
                                    id="dataInicialFiltrotarefas"
                                    type="date"
                                    value={dataInicial}
                                    onChange={(e) => setDataInicial(e.target.value)} />
                            </span>

                            <span>
                                <label htmlFor="dataFinalFiltrotarefas">Data Final</label>
                                <input
                                    id="dataFinalFiltrotarefas"
                                    type="date"
                                    value={dataFinal}
                                    onChange={(e) => setDataFinal(e.target.value)} />
                            </span>
                        </section>
                    </section>

                    <span id="botoesContainerFiltrosTarefas">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={() => setMaisFiltros(false)}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                            {!processando && 'Buscar Dados'}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>}
            <section id='fundoContainerPagina'>
                <table id='tabelaListaContainer'>
                    <thead>
                        <tr>
                            <th id='ladoEsquerdoContent' align='left'>Cliente</th>
                            <th align='left'>Processo</th>
                            <th align='left'>Título</th>
                            <th align='left' className='usuarioResponsavelProcesso'>Responsável</th>
                            <th id='progressoProcesso' align='left'>Progresso</th>
                            <th className='prazoProcesso' align='center'>Prazo</th>
                            <th id='situacaoProcesso' align='center'>Situação</th>
                            <th>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processos.map((processo) => (
                            <tr key={processo.id}>
                                <td id='primeiraColuna' onClick={() => exibirModalDadosProcessos(processo, processo.id)}>{processo.clienteProcesso.nomeFantasia}</td>
                                <td onClick={() => exibirModalDadosProcessos(processo, processo.id)}>{processo.modelosProcesso.titulo}</td>
                                <td onClick={() => exibirModalDadosProcessos(processo, processo.id)}>{processo.titulo}</td>
                                <td className='usuarioResponsavelContent usuarioResponsavelProcesso' onClick={() => exibirModalDadosProcessos(processo, processo.id)}>
                                    <img className='usuarioResponsavel' src={processo.responsavelProcesso.avatar ? processo.responsavelProcesso.avatar : avatarDefault} alt='' />
                                    {processo.responsavelProcesso.nome}
                                </td>
                                <td id='progressoProcesso'>
                                    <svg width={100} height={20} rx={5} ry={5}>
                                        <rect rx={5} ry={5} width={100} height={20} stroke='rgba(106, 108, 114, 0.2)' strokeWidth={2} fill='none'/>
                                        <rect rx={5} ry={5} width={(processo.tarefasConcluidas/processo.tarefasTotais)*100} height={20} fill='#25ae88'/>
                                    </svg>
                                </td>
                                <td className='prazoProcesso' align='center' onClick={() => exibirModalDadosProcessos(processo, processo.id)}>{`${processo.previsaoTermino.slice(8,10)}-${processo.previsaoTermino.slice(5,7)}-${processo.previsaoTermino.slice(0,4)}`}</td>
                                <td id='situacaoProcesso' align='center' onClick={() => exibirModalDadosProcessos(processo, processo.id)}>
                                    <DivSituacao texto={`${processo.situacao.charAt(0).toUpperCase()}${processo.situacao.substring(1)}`} cor={processo.situacao}/>
                                </td>
                                <td id='ladoDireitoContent' align='center'>
                                    <Permissao permissoes={['master']}>
                                        {processo.situacao !== 'concluída' ? <img className='apagarIconeItemTabela' title='Excluir Processo' src={apagarImg} alt='' onClick={() => deletarProcesso(processo.id)}/> : null}
                                    </Permissao>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>
        </div>
    )
}

export default Processos